import { Box, Table, TableBody, TableHead, TableRow, Typography } from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  PaginationTable,
  RowTableCell,
} from '../../../../common/components';

/**
 * Renderiza la tabla de suscriptores en app mobile.
 * @param {Object} props - Props del componente.
 * @param {Array<Object>} props.rows - Filas del reporte.
 * @param {Object} props.pagination - Datos de paginación.
 * @param {Function} props.onPageChange - Handler de página.
 * @param {Function} props.onRowsPerPageChange - Handler de items por página.
 * @returns {JSX.Element} Tabla de suscriptores en app.
 */
const AppSubscribersTable = ({
  rows,
  pagination,
  onPageChange,
  onRowsPerPageChange,
}) => {
  if (!rows.length) {
    return (
      <GeneralTableBox>
        <Typography variant="body1" color="text.secondary">
          No se encontraron registros que coincidan con los filtros seleccionados.
        </Typography>
      </GeneralTableBox>
    );
  }

  const buildTruncatedText = (value, maxWidth = 260, titleValue) => (
    <Typography
      variant="body2"
      title={titleValue ?? value}
      sx={{
        maxWidth,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {value}
    </Typography>
  );

  const getEmailTitle = (emailValue) => (emailValue || '-').replace(/;/g, '\n');

  return (
    <Box>
      <GeneralTableBox>
        <Table size="small">
          <TableHead>
            <TableRow>
              <HeadTableCell sx={{ maxWidth: 240 }}>Suscriptor</HeadTableCell>
              <HeadTableCell sx={{ maxWidth: 260 }}>Email</HeadTableCell>
              <HeadTableCell sx={{ maxWidth: 180 }}>Celular</HeadTableCell>
              <HeadTableCell sx={{ maxWidth: 140 }}>Num. contrato</HeadTableCell>
              <HeadTableCell sx={{ maxWidth: 120 }}>Usa app</HeadTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow
                key={`${row.subscriber_uuid || 'subscriber'}-${row.contract_number || index}`}
                hover
              >
                <RowTableCell sx={{ maxWidth: 240 }}>
                  {buildTruncatedText(row.subscriber_name || 'Sin suscriptor', 240)}
                </RowTableCell>
                <RowTableCell sx={{ maxWidth: 260 }}>
                  {buildTruncatedText(row.email || '-', 260, getEmailTitle(row.email))}
                </RowTableCell>
                <RowTableCell sx={{ maxWidth: 180 }}>
                  {buildTruncatedText(row.phone || '-', 180)}
                </RowTableCell>
                <RowTableCell sx={{ maxWidth: 140 }}>{row.contract_number || '-'}</RowTableCell>
                <RowTableCell sx={{ maxWidth: 120 }}>{row.uses_app ? 'SI' : 'NO'}</RowTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </GeneralTableBox>
      {pagination?.pages > 1 && (
        <PaginationTable
          totalPages={pagination.pages}
          totalCount={pagination.total}
          page={pagination.page}
          onPageChange={onPageChange}
          rowsPerPage={pagination.rowsPerPage}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      )}
    </Box>
  );
};

export default AppSubscribersTable;
